export default {
  switch: false,
  shop_title_active: true,
  shop_title_top:-1
}